<div class="row">
  <div class="col-12">
    <lib-filter-list [configService]="pimMetadataListConfigService"></lib-filter-list>
  </div>
</div>
